import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SchoolAdminGroupService} from '../../../../../../services/school/school-admin-group.service';
import {ModalService} from '../../../../../../shared/modals/modal/modal.service';
import {StudentModel} from '../../../../../../models/authentication/student.model';
import {GroupQueryModel} from '../../../../../../models/school/group.model';
import {EVOStudentListSort} from '../../../../../../shared/list-views/evo-student-list-view/evo-student-list-view.component';
import {ErrorModel} from '../../../../../../models/shared/error.model';

@Component({
  selector: 'app-school-admin-group-detail-add-students',
  templateUrl: './school-admin-group-detail-add-students.component.html',
  styleUrls: ['./school-admin-group-detail-add-students.component.css']
})
export class SchoolAdminGroupDetailAddStudentsComponent implements OnInit {

  _show = false;
  @Input('show')
  set show(show: boolean) {
    if (this._show !== show) {
      this._show = show;
      this.resetState();
      this.fetchStudentsForGroup();
    }
  }

  get show(): boolean {
    return this._show;
  }

  _groupId: string;
  @Input('groupId')
  set groupId(groupId: string) {
    this._groupId = groupId;
    this.fetchStudentsForGroup();
  }

  get groupId(): string {
    return this._groupId;
  }

  hasMoreData = false;
  students: StudentModel[] = [];
  selectedStudents: StudentModel[] = [];
  /**
   * Used when netowkring to disable the button
   */
  addingStudents = false;

  @Output() close = new EventEmitter();
  @Output() studentsAdded = new EventEmitter();

  filter = new GroupQueryModel();

  sort = new EVOStudentListSort();

  constructor(private modalSv: ModalService,
              private tSv: TranslateService,
              private groupSv: SchoolAdminGroupService) { }

  ngOnInit() {
    this.filter.sort = 1;
  }

  fetchStudentsForGroup() {

    if (this._groupId && this._show) {

      this.filter.skip = this.students.length;

      this.groupSv.fetchStudentsWithNoRelationshipToGroup(this.groupId, this.filter).subscribe((students) => {

        this.hasMoreData = students.length === this.filter.limit;

        for (const student of students) {
          if (this.students.filter((s) => s._id === student._id).length === 0) {
            this.students.push(student);
          }
        }

      });

    }

  }

  onFilterChanged(filter: GroupQueryModel) {

    this.filter = filter;
    this.students = [];
    this.fetchStudentsForGroup();

  }

  onSearchStudents(studentName: string) {

    if (studentName === '' || !studentName) {
      this.filter.name = null;
    } else {
      this.filter.name = studentName;
    }

    this.students = [];
    this.selectedStudents = [];

    this.fetchStudentsForGroup();

  }

  onSortChanged(sort: EVOStudentListSort) {

    this.filter.sort = sort.nameSort;
    this.students = [];
    this.selectedStudents = [];

    this.fetchStudentsForGroup();

  }

  onAddClicked() {

    this.addingStudents = true;
    const studentsToAdd = [];
    for (const sId of this.selectedStudents) {
      studentsToAdd.push(sId);
    }

    this.groupSv.addStudentsToGroup(this.groupId, studentsToAdd).subscribe((students) => {

      this.addingStudents = false;
      this.selectedStudents = [];
      this.modalSv.showAlertModal(this.tSv.instant('reusable.success'), this.tSv.instant('reusable.successMessage'));

      if (this.studentsAdded) {
        this.studentsAdded.emit();
      }

    }, (err: ErrorModel) => {
      this.addingStudents = false;
      this.modalSv.showTranslatedErrorModal(err);
    });

  }

  onCloseClicked() {
    this._show = false;
    if (this.close) {
      this.close.emit();
    }
  }

  resetState() {
    this.filter = new GroupQueryModel();
    this.students = [];
  }

}
